import { createClient, configureChains } from "wagmi";
import { polygon, polygonMumbai } from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";
import { getDefaultWallets } from "@rainbow-me/rainbowkit";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";

const chainConfig = {
  137: {
    rpc: import.meta.env.VITE_ALCHEMY_RPC_POLY,
    alchemyKey: import.meta.env.VITE_ALCHEMY_API_POLY,
  },
  80001: {
    rpc: import.meta.env.VITE_ALCHEMY_RPC_TEST,
    alchemyKey: import.meta.env.VITE_ALCHEMY_API_TEST,
  },
};

const { chains, provider } = configureChains(
  [polygon, polygonMumbai],
  [
    jsonRpcProvider({
      rpc: (chain) => ({
        http: `${chainConfig[chain.id].rpc}${chainConfig[chain.id].alchemyKey}`,
      }),
    }),
  ],
  [publicProvider()]
);

const { connectors } = getDefaultWallets({
  appName: import.meta.env.VITE_WALLETCONNECT_APP_NAME,
  projectId: import.meta.env.VITE_WALLETCONNECT_ID,
  chains,
});

const client = createClient({
  autoConnect: true,
  connectors,
  provider,
});

export { client, chains };
